
import Vue from "vue";
import { ExtraFieldNamesConfig } from "../models/dossier-configs/extra-field-names-config";
import { getExtraFieldKeyNames, IExtraFields } from "../utils/models/extra-fields";
import { ExtraFieldNumberConfig } from "@/models/dossier-configs/extra-field-number-config";
import AppExtraFieldsEditText from "./ExtraFieldsEditText.vue";
import { ExtraFieldBaseConfig } from "@/models/dossier-configs/extra-field-base-config";
import { ExtraFieldTextConfig } from "@/models/dossier-configs/extra-field-text-config";

export default Vue.extend({
	props: {
		value: {
			type: Object as () => IExtraFields,
			required: true
		},
		nameSettings: {
			type: Object as () => ExtraFieldNamesConfig,
			required: true
		},
		saleTypeId: Number
	},
	computed: {
		locale(): string {
			return this.$i18n.locale;
		},
		numKeys():(keyof IExtraFields)[] {
			return getExtraFieldKeyNames("Num", this.nameSettings.NumOrder).filter((k:keyof ExtraFieldNamesConfig)=>this.isActive(k));
		},
		textKeys():(keyof IExtraFields)[] {
			return getExtraFieldKeyNames("Text", this.nameSettings.TextOrder).filter((k:keyof ExtraFieldNamesConfig)=>this.isActive(k));
		},
		boolKeys():(keyof IExtraFields)[] {
			return getExtraFieldKeyNames("Bool", this.nameSettings.BoolOrder).filter((k:keyof ExtraFieldNamesConfig)=>this.isActive(k));
		},
		timeKeys():(keyof IExtraFields)[] {
			return getExtraFieldKeyNames("Time", this.nameSettings.TimeOrder).filter((k:keyof ExtraFieldNamesConfig)=>this.isActive(k));
		}
	},
	methods: {
		getLabel(key:keyof ExtraFieldNamesConfig): string {
			if ((this.nameSettings[key] as string) != "") {
				return this.nameSettings[key] as string;
			}
			return key;
		},
		getDecimals(key:keyof ExtraFieldNamesConfig):number{
			return (this.nameSettings[`${key}Config` as keyof ExtraFieldNamesConfig] as ExtraFieldNumberConfig).Decimals;
		},
		isActive(key:keyof ExtraFieldNamesConfig): boolean {
			if (this.nameSettings[key] == "") return false;
			let conf = this.nameSettings[`${key}Config` as keyof ExtraFieldNamesConfig] as any as ExtraFieldBaseConfig;
			if (!conf) return true;
			if (this.saleTypeId) {
				if (conf.OnlyShownForSaleTypes.length > 0 && conf.OnlyShownForSaleTypes.indexOf(this.saleTypeId) == -1){
					return false;
				}
			}
			if (conf.HideInEditAndInfo) return false;
			return true;
		},
		getTextConfig(key:keyof ExtraFieldNamesConfig):ExtraFieldTextConfig{
			return (this.nameSettings[`${key}Config` as keyof ExtraFieldNamesConfig] as ExtraFieldTextConfig);
		}
	},
	components: {
		AppExtraFieldsEditText
	},
	i18nEx: {
		componentPrefix: "components.ExtraFieldsEdit"
	}
});
